<template>
  <v-layout v-if="showList" class="request-list">

    <v-flex class="title">
      <h3>REQUEST LIST</h3>
    </v-flex>

    <v-flex>
      <hg-request-list-detail
        :hg-request-lists="hgRequestLists"
        :hg-show-all="showAll"
        @copy="copy"/>
    </v-flex>

    <v-flex class="actions">
        <hg-create-list-button
          :hg-eligible-reports="hgEligibleReports"
          :hg-button-style="'v-btn-primary'"/>
        <button
          v-if="showViewAllLink && !showAllLists"
          type="button"
          @click="showAllLists = true"
          class="btn-tertiary view-all">VIEW ALL LISTS</button>
    </v-flex>

  </v-layout>
</template>

<script>
import RequestListDetail from './RequestListDetail.vue';
import CreateListButton from './CreateListButton.vue';

export default {
  data() {
    return {
      showAllLists: false,
    };
  },
  props: {
    hgRequestLists: {
      type: Object,
      required: true,
    },
    hgEligibleReports: {
      type: Array,
      required: true,
    },
    hgFolderStatus: {
      type: Object,
      required: true,
    },
  },
  components: {
    'hg-request-list-detail': RequestListDetail,
    'hg-create-list-button': CreateListButton,
  },
  computed: {
    listCount() {
      return this.hgRequestLists.lists ? this.hgRequestLists.lists.length : 0;
    },
    showList() {
      return this.listCount > 0 && !this.hgFolderStatus.blocked;
    },
    showViewAllLink() {
      return this.listCount > 1;
    },
    showAll() {
      return this.showAllLists;
    },
  },
  methods: {
    copy(data) {
      this.$emit('copy', data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/vars/theme';

.request-list {
  background-color: rgba(255, 255, 255, 0.9);
  flex-direction: column;
  height: auto !important;
  margin-bottom: 30px;
  margin-top: 30px;
  padding: 50px;
}

h3 {
  padding-bottom: 10px;
}

button {
  margin: 0;
}

.title {
  border-bottom: solid 2px $theme-color-primary;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.btn-tertiary {
  text-decoration: none;
}

.actions {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

@media all and (max-width: 655px) {
  .request-list {
    border: solid 2px rgba(0, 0, 0, 0.15);
    margin: 30px;
    padding: 50px 25px 15px 25px;
  }
}

@media all and (max-width: 800px) {
  h3 {
    padding-bottom: 30px;
    text-align: center;
  }

  .title {
    align-items: center;
    flex-direction: column;
    padding-bottom: 20px;
  }

  .actions {
    align-items: center;
    flex-direction: column;
  }

  .view-all {
    margin-top: 30px
  }
}
</style>
